import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const createWarehouseProcessStage = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/garment-process-stage', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putWarehouseProcessStage = (warehouseId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/garment-process-stage', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getWarehouseProcessStage = warehouseId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/garment-process-stage', // for android use
    headers: getHeaders(),
  });
};


export const postWarehouseProcessStageSwap = (warehouseId,data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/' +
      warehouseId +
      '/garment-process-stage-swap', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postWarehouseProcessStageAppServiceStage = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/app-service-stage',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getWarehouseProcessStageAppServiceStage = warehouseId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/ware-house-process/app-service-stage/' + warehouseId, // for android use
    headers: getHeaders(),
  });
};

// curl --location 'https://dhobicart.in/warehouse/api/secure/ware-house-process/app-service-stage/1' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Cookie: JSESSIONID=0118A4E1A6EFB605F7CFCEBE34627B6C'

// curl --location 'https://dhobicart.in/warehouse/api/secure/ware-house-process/app-service-stage' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQzNjczMDc3LCJleHAiOjE3NDQyNzc4Nzd9.dpcmAIebyyVnQmWjnGIDZ7uBF0gicwQT4WXPBizjztAX0Zc8SxqP3NO0ofd2kx_rTsKcxtndgfx0eKoo3W5M1A' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=87A740E3009D1DF78C7861D763B3FC6D' \
// --data '{
//     "wareHouseGarmentProcessStageId" :1,
//     "appServiceList" : [1,2]
// }'